import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { oliApi, erroreOli, dataIt, oggiIso } from './api';

const MODALITA = ['consegna a mano', 'PEC', 'RENTRI', 'email'];
const CAMPO = 'w-full h-11 px-3 rounded-lg border border-gray-300';

// Copia del FIR controfirmata e datata dall'impianto: va ricevuta entro 3 mesi dal ritiro
export const CopiaFirmataDialog = ({ prelievo, onClose, onSaved }) => {
  const [data, setData] = useState(oggiIso());
  const [modalita, setModalita] = useState(MODALITA[0]);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!prelievo) return;
    setData(prelievo.copia_ritorno?.data_ricezione || oggiIso());
    setModalita(prelievo.copia_ritorno?.modalita || MODALITA[0]);
    setFile(null);
  }, [prelievo]);

  const salva = async () => {
    const form = new FormData();
    form.append('data_ricezione', data);
    form.append('modalita', modalita);
    if (file) form.append('file', file);
    setBusy(true);
    try {
      await oliApi.post(`/prelievi/${prelievo.id}/copia-ritorno`, form);
      toast.success('Copia firmata registrata');
      onSaved();
    } catch (e) {
      toast.error(erroreOli(e, 'Non sono riuscito a salvare'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!prelievo} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="oli-copia-dialog">
        <DialogHeader>
          <DialogTitle>Copia firmata dall'impianto</DialogTitle>
          <DialogDescription>
            Ritiro del {dataIt(prelievo?.data_prelievo)}: la copia del FIR firmata e datata dall'impianto deve arrivarti
            entro il {dataIt(prelievo?.stato_copia?.scadenza)}. Te la consegna il trasportatore, via PEC o dal portale RENTRI.
          </DialogDescription>
        </DialogHeader>
        <label className="text-sm font-medium text-gray-700">Ricevuta il
          <input type="date" value={data} min={prelievo?.data_prelievo} max={oggiIso()} onChange={(e) => setData(e.target.value)}
            className={`${CAMPO} mt-1`} data-testid="oli-copia-data" />
        </label>
        <label className="text-sm font-medium text-gray-700">Come è arrivata
          <select value={modalita} onChange={(e) => setModalita(e.target.value)} className={`${CAMPO} mt-1`} data-testid="oli-copia-modalita">
            {MODALITA.map((m) => <option key={m} value={m}>{m}</option>)}
          </select>
        </label>
        <label className="text-sm font-medium text-gray-700">Foto o PDF della copia (consigliato)
          <input type="file" accept="image/*,.pdf" onChange={(e) => setFile(e.target.files[0] || null)}
            className="block w-full text-sm mt-1" data-testid="oli-copia-file" />
        </label>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose} data-testid="oli-copia-chiudi">Chiudi</Button>
          <Button onClick={salva} disabled={busy || !data} className="bg-emerald-700 hover:bg-emerald-800 text-white" data-testid="oli-copia-salva">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Salva'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
